import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../../PredefinedPIXIAnchorPoint";

export class CheckBox extends PIXI.Container {

    protected sprite: PIXI.Sprite;
    protected uncheckedBaseTexture: PIXI.Texture;
    protected uncheckedOnHoverTexture: PIXI.Texture;
    protected uncheckedOnClickTexture: PIXI.Texture;
    protected uncheckedInactiveTexture: PIXI.Texture;
    protected checkedBaseTexture: PIXI.Texture;
    protected checkedOnHoverTexture: PIXI.Texture;
    protected checkedOnClickTexture: PIXI.Texture;
    protected checkedInactiveTexture: PIXI.Texture;

    private onClickedSubscribers: Array<Function> = [];
    private sound: Howl;
    private isChecked = false;

    constructor(uncheckedTexturePath: string, uncheckedOnHoverTexturePath: string, uncheckedOnClickTexturePath: string,
                uncheckedInactiveTexturePath: string, checkedTexturePath: string, checkedOnHoverTexturePath: string,
                checkedOnClickTexturePath: string, checkedInactiveTexturePath: string, soundNamePath: string) {
        super();
        this.uncheckedBaseTexture = PIXI.Texture.fromFrame(uncheckedTexturePath);
        this.uncheckedOnHoverTexture = PIXI.Texture.fromFrame(uncheckedOnHoverTexturePath);
        this.uncheckedOnClickTexture = PIXI.Texture.fromFrame(uncheckedOnClickTexturePath);
        this.uncheckedInactiveTexture = PIXI.Texture.fromFrame(uncheckedInactiveTexturePath);
        this.checkedBaseTexture = PIXI.Texture.fromFrame(checkedTexturePath);
        this.checkedOnHoverTexture = PIXI.Texture.fromFrame(checkedOnHoverTexturePath);
        this.checkedOnClickTexture = PIXI.Texture.fromFrame(checkedOnClickTexturePath);
        this.checkedInactiveTexture = PIXI.Texture.fromFrame(checkedInactiveTexturePath);
        this.sprite = new PIXI.Sprite(this.uncheckedBaseTexture);
        this.sprite.interactive = true;
        this.sprite.buttonMode = true;
        this.sprite.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(this.sprite);
        this.addOnMouseDownLister();
        this.addMouseOverListener();

        this.sound = new Howl({
            src: [soundNamePath],
        });
    }

    public get checked(): boolean {
        return this.isChecked;
    }

    public set checked(value: boolean) {
        this.isChecked = value;
        this.changeSprite();
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.onClickedSubscribers.push(subscriber);
    }

    private clickListener(): void {
        this.isChecked = !this.isChecked;
        this.changeSprite();
        this.sound.play();
        this.callAllSubscribers();
    }

    private changeSprite(): void {
        if (this.isChecked) {
            this.sprite.texture = this.checkedBaseTexture;
        } else {
            this.sprite.texture = this.uncheckedBaseTexture;
        }
    }

    private addOnMouseDownLister(): void {
        this.sprite.on("pointerdown", () => {

            this.clickListener();
            if (this.isChecked) {
                this.sprite.texture = this.checkedOnClickTexture;
            } else {
                this.sprite.texture = this.uncheckedOnClickTexture;
            }
        });
        this.sprite.on("pointerup", () => {
            if (this.isChecked) {
                this.sprite.texture = this.checkedOnHoverTexture;
            } else {
                this.sprite.texture = this.uncheckedOnHoverTexture;
            }
        });
        this.sprite.on("pointercancel", () => {
            if (this.isChecked) {
                this.sprite.texture = this.checkedBaseTexture;
            } else {
                this.sprite.texture = this.uncheckedBaseTexture;
            }
        });
        this.sprite.on("pointerupoutside", () => {
            if (this.isChecked) {
                this.sprite.texture = this.checkedBaseTexture;
            } else {
                this.sprite.texture = this.uncheckedBaseTexture;
            }
        });
    }

    private addMouseOverListener(): void {
        this.sprite.on("pointerover", () => {
            if (this.isChecked) {
                this.sprite.texture = this.checkedOnHoverTexture;
            } else {
                this.sprite.texture = this.uncheckedOnHoverTexture;
            }
        });
        this.sprite.on("pointerout", () => {
            if (this.isChecked) {
                this.sprite.texture = this.checkedBaseTexture;
            } else {
                this.sprite.texture = this.uncheckedBaseTexture;
            }
        });
    }

    private callAllSubscribers(): void {
        for (let i = 0; i < this.onClickedSubscribers.length; i++) {
            this.onClickedSubscribers[i](this.isChecked);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/controlElements/CheckBox.ts